module.exports = __webpack_public_path__ + "media/images/image-2-bc511c2e.jpg";